import { render, staticRenderFns } from "./XubioMobileApp.vue?vue&type=template&id=11afcb52&scoped=true"
import script from "./XubioMobileApp.vue?vue&type=script&lang=js"
export * from "./XubioMobileApp.vue?vue&type=script&lang=js"
import style0 from "./XubioMobileApp.vue?vue&type=style&index=0&id=11afcb52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.39_css-loader@6.11.0_webpack@5.108.3_postcss@8_02c27052d031722e4d6624d6038d9593/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11afcb52",
  null
  
)

export default component.exports